import * as angular from 'angular';
import {
  ExportConsolidatedBillingOrderTranslationsPayloadModel
} from "../models/export-consolidated-billing-order-translations-payload.model";
import {
  ExportConsolidatedBillingOrdersTablePayloadModel
} from "../models/export-consolidated-billing-orders-table-payload.model";
import {SapDocumentType} from "../types/sap-document.type";
import {IHttpService} from "angular";
import {SplitService} from "../../commons/services/split-service.service";
import {ApiConfig} from "../../commons/models/api-config.model";

export class ConsolidatedBillingOrdersRequests {

  /* @ngInject */
  constructor(private $consolidatedBillingOrders, private ConsolidateBillingOrdersAPI,
              private apiConfig: ApiConfig, private $http: IHttpService, private splitService: SplitService) {
  }

  getOne(consolidatedId) {
    const api = this.ConsolidateBillingOrdersAPI.actions.getOne;
    return this.$$call(api, {}, {}, {id: consolidatedId});
  }

  create(payload) {
    const api = this.ConsolidateBillingOrdersAPI.actions.create;
    return this.$$call(api, {}, payload, {});
  }

  update(consolidatedId, name?, docDate?, comment?, billTo?) {
    const api = this.ConsolidateBillingOrdersAPI.actions.update;
    return this.$$call(api, {}, {
      name: name,
      docDate: docDate,
      comment: comment,
      billTo: billTo
    }, {id: consolidatedId});
  }

  bulkEditDate(payload) {
    const api = this.ConsolidateBillingOrdersAPI.actions.bulkEdit;
    return this.$$call(api, {}, payload, {});
  }

  addBillingOrders(consolidatedId, payload) {
    const api = this.ConsolidateBillingOrdersAPI.actions.addBillingOrders;
    return this.$$call(api, {}, payload, {id: consolidatedId});
  }

  removeBillingOrders(consolidatedId, removeBillingOrderIds?, excludeBillingOrderIds?, removeAll?) {
    const api = this.ConsolidateBillingOrdersAPI.actions.removeBillingOrders;
    return this.$$call(api, {}, {
      removeBillingOrderIds: removeBillingOrderIds,
      excludeBillingOrderIds: excludeBillingOrderIds,
      removeAll: removeAll
    }, {id: consolidatedId});
  }

  getPDF(consolidatedId, proformaPdfTemplate, includeEmptyPrices: boolean, zoneId?) {
    const url = `${this.apiConfig.baseUrl}/consolidatedBillingOrder/${consolidatedId}/actions/download`
    return this.$http.post<any>(url, {}, {
      params: {
        siteId: this.splitService.getSiteId(),
        zoneId: zoneId,
        includeEmptyPrices: includeEmptyPrices,
        proformaPdfTemplate: proformaPdfTemplate
      },
      responseType: "arraybuffer"
    });
  }

  exportPDF(payload) {
    const api = this.ConsolidateBillingOrdersAPI.actions.exportPDF;
    return this.$$call(api, {}, payload, {});
  }

  exportCSV(consolidatedId, payload: ExportConsolidatedBillingOrderTranslationsPayloadModel, includeEmptyPrices?: boolean, zoneId?) {
    const api = this.ConsolidateBillingOrdersAPI.actions.exportCSV;
    return this.$$call(api, {zoneId: zoneId, includeEmptyPrices: includeEmptyPrices}, payload, {id: consolidatedId});
  }

  exportTable(payload: ExportConsolidatedBillingOrdersTablePayloadModel) {
    const api = this.ConsolidateBillingOrdersAPI.actions.exportTable;
    return this.$$call(api, {}, payload, {});
  }

  createInvoice(consolidatedId, sapDocumentType: SapDocumentType) {
    const api = this.ConsolidateBillingOrdersAPI.actions.createInvoice;
    return this.$$call(api, {}, {sapDocumentType: sapDocumentType}, {id: consolidatedId});
  }

  refund(consolidatedId: string, refundAmount: number, comment: string, dueDate: string) {
    const api = this.ConsolidateBillingOrdersAPI.actions.refund;
    return this.$$call(api, {}, {
      refundAmount: refundAmount,
      comment: comment,
      dueDate: dueDate,
    }, {id: consolidatedId});
  }

  payManually(consolidatedId: string, payload?: { invoiceId: string }) {
    const api = this.ConsolidateBillingOrdersAPI.actions.payManually;
    return this.$$call(api, {}, payload, {id: consolidatedId});
  }

  resetPayManually(payload: {proformaId: string}) {
    const api = this.ConsolidateBillingOrdersAPI.actions.resetPayManually;
    return this.$$call(api, {}, payload, {});
  }

  // ******************************
  // Internal methods
  // ******************************

  private $$call(_apiCall, _params, _data, _options) {
    return this.$consolidatedBillingOrders().$call(_apiCall, _params, _data, _options);
  }
}

angular
  .module('bringoz.admin.billing-accounts')
  .service('consolidatedBillingOrdersRequests', ConsolidatedBillingOrdersRequests);
